import { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { Trans, useTranslation } from 'next-i18next/pages'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useGetLoginUrl } from 'shared/utils/url-utils'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

interface CourseLoginOrPurchaseScreenProps {
  salesPageLink: string
}

export const CourseLoginOrPurchaseScreen = ({
  salesPageLink,
}: CourseLoginOrPurchaseScreenProps): ReactNode => {
  const { t } = useTranslation()

  const loginUrl = useGetLoginUrl()

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(`course__info-screen--login-or-purchase`)}
      text={
        <Trans
          i18nKey="course.login_or_purchase_message"
          components={{
            i: <div className="flex justify-center" />,
            a: <LinkWithoutPrefetch className="primary-link" href={loginUrl} />,
          }}
        />
      }
      buttons={
        <Button
          variant="primary"
          className={`border-THEME-secondary! bg-THEME-secondary! font-bold text-THEME-block-background! hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled! ${addPublicCustomClassNamePrefix(['course__button', 'course__button--primary', 'course__button--purchase-course'])}`}
          render={<LinkWithoutPrefetch href={salesPageLink} target="_blank" />}
        >
          {t('course.purchase_course_button')}
        </Button>
      }
    />
  )
}
